import React from 'react'
import Layout from '../../components/layouts/Layout'
import { Outlet } from 'react-router-dom'

const Administration = () => {
  return (
    <Layout pageTitle={`Administration`}>
      <Outlet />
    </Layout>
  )
}

export default Administration